/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import s from './ExpressLogo.module.scss';

function ExpressLogo(props) {
  const { logo } = props;
  return (
    <div className={s.logoContainer}>
      <a href="/" data-testid="express-logo" aria-label="express Logo">
        <img
          className={s.image}
          alt="Express"
          src={logo}
          width="124"
          height="20"
        />
      </a>
    </div>
  );
}

ExpressLogo.propTypes = {
  logo: PropTypes.string,
};

export default ExpressLogo;
